import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from '../login/login.vue'
Vue.use(Router)

const HomeLayout = () => import('../homepage/index.vue')

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/r',
      name: 'qrRedirect',
      component: () => import('../basic/librarytable/r.vue'),
    },
    {
      path: '/index',
      component: HomeLayout,
      children: [
        {
          path: 'secondMenu',
          name: "secondMenu",
          component: () => import('../components/secondMenu.vue'),
        },
        {
          path: 'gentable/:id',
          name: "gentable",
          component: () => import('../basic/general/gentable.vue'),
        },
        {
          path: 'systemsettings',
          name: "systemsettings",
          component: () => import('../basic/systemsettings/systemsettings.vue'),
        },
        {
          path: 'column',
          name: "column",
          component: () => import('../basic/column/column.vue'),
        },
        {
          path: 'librarytable',
          name: "librarytable",
          component: () => import('../basic/librarytable/librarytabletabs.vue'),
        },
        {
          path: 'usermanag',
          name: "usermanag",
          component: () => import('../basic/usermanag/usermanag.vue'),
        },
        {
          path: 'permission',
          name: "permission",
          component: () => import('../basic/permission/permission.vue'),
        },
        {
          path: 'dictionary',
          name: "dictionary",
          component: () => import('../basic/dictionary/dictionary.vue'),
        },
        {
          path: 'genform',
          name: "genform",
          component: () => import('../basic/general/genform.vue'),
        },
        {
          path: 'genformedit',
          name: "genformedit",
          component: () => import('../basic/general/genformedit.vue'),
        },
        {
          path: 'gengeneral',
          name: "gengeneral",
          component: () => import('../basic/general/gengeneral.vue'),
        },
        {
          path: 'classscheduling',
          name: "classscheduling",
          meta: {
            title: '课程表'
          },
          component: () => import('../basic/general/classscheduling.vue'),
        },
        {
          path: 'paiKeSchedule',
          name: "paiKeSchedule",
          meta: {
            title: '排课管理(V2)'
          },
          component: () => import('../basic/general/paiKeScheduleNew.vue'),
        },
        {
          path: 'classschedulingBatch',
          name: "classschedulingBatch",
          meta: {
            title: '课程表'
          },
          component: () => import('../basic/general/classschedulingBatch.vue'),
        },
        {
          path: 'schoolcalendar/:id',
          name: "schoolcalendar",
          meta: {
            title: '校历'
          },
          component: () => import('../basic/general/schoolcalendar.vue'),
        },
        {
          path: 'flowchart',
          name: "flowchart",
          meta: {
            title: '流程图'
          },
          component: () => import('../basic/general/flowchart.vue'),
        },
        {
          path: 'scheduleinquiry',
          name: "scheduleinquiry",
          component: () => import('../basic/general/scheduleinquiry.vue'),
        },
        {
          path: 'undeveloped',
          name: "undeveloped",
          component: () => import('../components/undeveloped.vue'),
        },
        {
          path: 'largescreen',
          name: "largescreen",
          component: () => import('../basic/databorad/index.vue'),
        },
        {
          path: 'largescreen2',
          name: "largescreen2",
          component: () => import('../basic/databorad2/index.vue'),
        },
        {
          path: 'log_mgr',
          name: "log_mgr",
          component: () => import('../basic/logMgr/logmgr.vue'),
        },
        {
          path: 'view/:id',
          name: "view",
          component: () => import('../basic/view/view.vue'),
        },
        {
          path: 'studentregistration',
          name: "studentregistration",
          meta: {
            title: '学籍证明'
          },
          component: () => import('../basic/student/registration.vue'),
        },
        {
          path: 'studenttranscript',
          name: "studenttranscript",
          meta: {
            title: '学生成绩单'
          },
          component: () => import('../basic/student/transcript.vue'),
        },
        {
          path: 'rollcall',
          name: "rollcall",
          meta: {
            title: '上课点名册'
          },
          component: () => import('../basic/student/rollCall.vue'),
        },
        {
          path: 'dormitory',
          name: "dormitory",
          meta: {
            title: '宿舍管理'
          },
          component: () => import('../basic/dormitory/index.vue'),
        },
        // 流程审批模块（首页应用中心直接进入，无 submenu 外壳）
        {
          path: 'wftask',
          name: "wfTask",
          meta: {
            title: '审批任务中心'
          },
          component: () => import('../basic/wf/taskCenter.vue'),
        },
        {
          path: 'wfinitiate',
          name: "wfInitiate",
          meta: {
            title: '发起流程'
          },
          component: () => import('../basic/wf/initiation.vue'),
        },
        {
          path: 'wfmyinitiated',
          name: "wfMyInitiated",
          meta: {
            title: '我的发起'
          },
          component: () => import('../basic/wf/myInitiated.vue'),
        },
        {
          path: 'wfmessages',
          name: "wfMessages",
          meta: {
            title: '流程消息'
          },
          component: () => import('../basic/wf/messageCenter.vue'),
        },
        {
          path: 'wfagent',
          name: "wfAgent",
          meta: {
            title: '出差代理设置'
          },
          component: () => import('../basic/wf/agentSetting.vue'),
        },
        {
          path: 'wfadmin',
          name: "wfAdmin",
          meta: {
            title: '流程管理后台',
            requireAuth: 'WfAdmin'
          },
          component: () => import('../basic/wf/adminCenter.vue'),
        },
        {
          path: 'wftemplate',
          name: "wfTemplate",
          meta: {
            title: '流程模板管理',
            requireAuth: 'WfTemplate'
          },
          component: () => import('../basic/wf/templateManage.vue'),
        }
      ]
    },
    {
      path: '/basic',
      component: HomeLayout,
      children: [
        {
          path: '',
          name: "basic",
          component: () => import('../basic/basic.vue'),
        }
      ]
    },
    {
      path: '/submenu',
      component: HomeLayout,
      children: [
        {
          path: '',
          name: 'submenu',
          component: () => import('../basic/submenu.vue'),
          // 增加:id用来记录当前页面是否切换
          children: [
            {
              path: 'empty',
              name: 'submenu-empty',
              component: () => import('../components/undeveloped.vue')
            },
            {
              path: 'gentable/:id',
              name: 'submenu-gentable',
              component: () => import('../basic/general/gentable.vue'),
            },
            {
              path: 'genformedit/:id',
              name: 'submenu-genformedit',
              component: () => import('../basic/general/genformedit.vue')
            },
            {
              path: 'gengeneral/:id',
              name: 'submenu-gengeneral',
              component: () => import('../basic/general/constraints.vue')
            },
            {
              path: 'view/:id',
              name: 'submenu-view',
              component: () => import('../basic/view/view.vue'),
            },
            {
              path: 'classscheduling/:id',
              name: 'submenu-classscheduling',
              component: () => import('../basic/general/classscheduling.vue'),
            },
            {
              path: 'paiKeSchedule/:id',
              name: 'submenu-paiKeSchedule',
              component: () => import('../basic/general/paiKeScheduleNew.vue'),
            },
            {
              path: 'abnormal',
              name: 'submenu-abnormal',
              component: () => import('../basic/general/componentForm/abnormal.vue')
            },
            {
              path: 'scheduleinquiry/:id',
              name: 'submenu-scheduleinquiry',
              component: () => import('../basic/general/scheduleinquiry.vue')
            },
            {
              path: 'calendar/:id',
              name: "submenu-calendar",
              component: () => import('../basic/general/schoolcalendar.vue'),
            },
            // 学籍证明
            {
              path: 'studentregistration',
              name: "submenu-studentregistration",
              meta: {
                title: '学籍证明'
              },
              component: () =>
                import('../basic/student/registration.vue'),
            },
            // 学生成绩单
            {
              path: 'studenttranscript',
              name: "submenu-studenttranscript",
              meta: {
                title: '学生成绩单'
              },
              component: () =>
                import('../basic/student/transcript.vue'),
            },
            //流程图
            {
              path: 'flowchart',
              name: "submenu-flowchart",
              component: () =>
                import('../basic/general/flowchart.vue'),
            },
            {
              path: 'dormitory',
              name: "submenu-dormitory",
              meta: {
                title: '宿舍管理'
              },
              component: () => import('../basic/dormitory/index.vue'),
            },
            // 流程审批模块
            {
              path: 'wf/task',
              name: 'wf-task-center',
              meta: { title: '审批任务中心' },
              component: () => import('../basic/wf/taskCenter.vue'),
            },
            {
              path: 'wf/initiate',
              name: 'wf-initiation',
              meta: { title: '发起流程' },
              component: () => import('../basic/wf/initiation.vue'),
            },
            {
              path: 'wf/my-initiated',
              name: 'wf-my-initiated',
              meta: { title: '我的发起' },
              component: () => import('../basic/wf/myInitiated.vue'),
            },
            {
              path: 'wf/messages',
              name: 'wf-message-center',
              meta: { title: '流程消息' },
              component: () => import('../basic/wf/messageCenter.vue'),
            },
            {
              path: 'wf/agent',
              name: 'wf-agent-setting',
              meta: { title: '出差代理设置' },
              component: () => import('../basic/wf/agentSetting.vue'),
            },
            {
              path: 'wf/admin',
              name: 'wf-admin-center',
              meta: { title: '流程管理后台', requireAuth: 'WfAdmin' },
              component: () => import('../basic/wf/adminCenter.vue'),
            },
            {
              path: 'wf/template',
              name: 'wf-template-manage',
              meta: { title: '流程模板管理', requireAuth: 'WfTemplate' },
              component: () => import('../basic/wf/templateManage.vue'),
            }
          ]
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js